/** @tsx tsx */
import React, { useContext, useState } from "react";
import { AppHeader, TabGroup, Tab, Avatar } from "@nike/eds";
import { NikeApp } from "@nike/nike-design-system-icons";
import { Link } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { AuthContext } from "../auth";
import { AuthState } from "@nike/aegis-auth-react/dist/types/store";
import { styled } from "@material-ui/core";

class KTab {
  tab: string;
  label: string;
}

const tabs: KTab[] = [
  { tab: "dashboard", label: "Dashboard" },
  { tab: "pdp-v3", label: "PDP V3" },
  { tab: "changelog", label: "Change Log" },
];

function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}


const parseUserInitials = (name: string = ''): string => {
  return compact(name.split(' '))
    .map(name => name.slice(0, 1).toUpperCase())
    .join('');
};

export default function KioskTabs() {
  const [activeTab, setActiveTab] = useState("dashboard");
  const userContext = useContext(AuthContext) as AuthState;
  return (
    <React.Fragment>
      <AppHeader
        logoSlot={<NikeApp />}
        appName={`Kiosk2`}
        toolbarSlot={
          <TabGroup
            name="tab-button-group"
            defaultId={activeTab}
            activeId={activeTab}
          >
            {tabs.map(tab => kioskTab(tab))}
          </TabGroup>
        }
        avatarSlot={userContext?.idClaims && <Avatar initials={parseUserInitials(userContext?.idClaims?.name)}></Avatar>}
      />
      <Outlet />
    </React.Fragment>
  );

  function kioskTab(tab: KTab) {
    return (
      <Link to={tab.tab} style={{ paddingBottom: "0px", display: "block", borderBottom: 0 }}>
        <Tab
          id={tab.tab}
          onClick={() => setActiveTab(tab.tab)}
        >
          {tab.label}
        </Tab>
      </Link>
    );
  }
}
